import React, { useState, useEffect } from "react";
import Link from "helpers/link";
import { useWindowScrollPosition } from "helpers/useWindowScrollPosition";
import Button from "helpers/button";
import ogrYellowLogo from "images/ogr_logo_yellow.png";
import CloseIcon from "images/close.png";
import fb from "images/fb.png";
import instagram from "images/instagram.png";
import twitter from "images/twitter.png";
import linkedin from "images/linkedin.png";
import phone from "images/phone.png";
import mail from "images/mail.png";

const Navbar = ({ data, social }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const scroll = useWindowScrollPosition();

  useEffect(() => {
    if (scroll > 200 && !isScrolled) setIsScrolled(true);
    if (scroll == 0 && isScrolled) setIsScrolled(false);
  }, [scroll]);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <nav className="bg-indigo-800 py-6 sticky top-0 z-50 w-full transition-all ease-in-out delay-150">
      <div className="container flex items-center justify-between lmd:justify-start">
        <div className="hidden md:block lmd:block mr-3">
          <button onClick={toggleMenu} className="flex items-center">
            {showMenu ? (
              <img src={CloseIcon} alt="close icon" className="w-6 h-6" />
            ) : (
              // <img src={MenuIcon} alt="menu icon" className="w-6 h-6" />
              <div className="h-7 w-10 flex items-center justify-center">
                <div>
                  <span className="block bg-white h-[3px] w-7 rounded-full mb-2"></span>
                  <span className="block bg-white h-[3px] w-7 rounded-full mb-2"></span>
                  <span className="block bg-white h-[3px] w-7 rounded-full"></span>
                </div>
              </div>

            )}
          </button>
        </div>
        <Link to="/" className="block w-32 lmd:w-20">
          <img src={ogrYellowLogo} className="w-full" alt="ogr_yellow_logo" />
        </Link>
        <div
          className={`w-full flex justify-end lmd:justify-start gap-9 ${isScrolled ? "flex-row items-center" : "flex-col-reverse items-end"
            } ${showMenu
              ? "lmd:absolute lmd:flex-col lmd:items-start lmd:justify-between lmd:h-[calc(100vh-80px)] lmd:top-20 lmd:left-0 lmd:bg-indigo-700 lmd:py-12 lmd:px-8"
              : "lmd:hidden"
            }`}
        >
          <div className="flex items-center justify-end lmd:flex-col lmd:items-start lmd:justify-between lmd:flex-1 lmd:max-h-96">
            {data?.links.map(({ text, url }, index) => (
              <Link
                className="paragraph text-gray-400 ml-14 lg:ml-10 lmd:mx-0 lmd:mb-4 lmd:text-lg lmd:font-medium"
                to={url}
                key={index}
                newTab={url.includes("https:")}
              >
                {text}
              </Link>
            ))}
          </div>
          <div className="flex items-center justify-end">
            {data?.additionalLinks && (
              <div className="flex items-center gap-4">
                {data.additionalLinks.map((button, index) => (
                  <Button button={button} key={index} />
                ))}
              </div>
            )}

            {/* <img src={Cart} alt="cart logo" className="w-6 h-6 ml-8 mr-6" />
            <img src={ProfileImg} alt="profile avatar" className="w-12 h-12" /> */}
          </div>
          <div className="w-full hidden lmd:block">
            <div className="flex justify-center">
              <a href={social.facebook} target="_blank" rel="noopener noreferrer">
                <img src={fb} alt="fb" className="w-6 h-6 mr-4" />
              </a>
              <a href={social.twitter} target="_blank" rel="noopener noreferrer">
                <img src={twitter} alt="twitter" className="w-6 h-6 mr-4" />
              </a>
              <a href={social.linkedin} target="_blank" rel="noopener noreferrer">
                <img src={linkedin} alt="linkedin" className="w-6 h-6 mr-4" />
              </a>
              <a href={social.instagram} target="_blank" rel="noopener noreferrer">
                <img src={instagram} alt="instagram" className="w-6 h-6 mr-4" />
              </a>
            </div>
            <div className="flex justify-center items-center my-3 text-gray-300">
              <a
                href={`mailto:${social.email}`}
                className="flex justify-center items-center"
              >
                <img src={mail} alt="mail" className="h-4 mr-2" />
                <p>support@oldgoldracing.com</p>
              </a>
            </div>
            <div className="flex justify-center items-center text-gray-300">
              <a
                href={`tel:${social.phone}`}
                className="flex justify-center items-center"
              >
                <img src={phone} alt="phone" className="h-4 mr-2" />
                <p>(+44)01242 650 630</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
